import defaultTheme from './defaultTheme';
const venmoTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#008cff', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#008cff', background: '#008cff' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#008cff' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#008cff', border: '#008cff', background: '#008cff' }), field: {
        focus: '#008cff',
        label: '#008cff',
        icon: '#008cff',
    } });
export default venmoTheme;
